import { TaskDTO } from '../dtos';
import { TaskTable } from '../views/task-table';
import { IS_NOT_NULL_OR_UNDEFINED } from '../../utils';
import { DATE_MDY } from '../../utils/date';
import { TASK_STATUS_UUID } from '../constants/task-status';

export const TASK_TABLE = (taskDTOs: Array<TaskDTO> = []): Array<TaskTable> => {
	let results: Array<TaskTable> = [];
	try {
		if (taskDTOs.length > 0) {
			taskDTOs.forEach((taskDTO) => {
				let row = {} as TaskTable;

				row.id = taskDTO.id;
				row.status = TASK_STATUS_UUID[taskDTO.statusId];
				row.title = taskDTO.title;
				row.projectName = IS_NOT_NULL_OR_UNDEFINED(taskDTO.project) ? taskDTO.project.name : '';
				row.carrierName = IS_NOT_NULL_OR_UNDEFINED(taskDTO.carrier)
					? taskDTO.carrier.businessName
					: '';
				row.dueDate = IS_NOT_NULL_OR_UNDEFINED(taskDTO.dueDate)
					? DATE_MDY(new Date(DATE_MDY(taskDTO.dueDate)))
					: '';
				row.assigneeId = taskDTO.assigneeId;
				row.projectId = IS_NOT_NULL_OR_UNDEFINED(taskDTO.project) ? taskDTO.project.id : '';
				row.carrierId = IS_NOT_NULL_OR_UNDEFINED(taskDTO.carrier) ? taskDTO.carrier.id : '';
				row.createdById = taskDTO.userId;

				results.push(row);
			});
		}
	} catch (error) {
		console.log('TASK_TABLE error: ', error);
	}

	return results;
};
